app.mediator.registerModule(MODULE_NAME__RESET_PASSWORD_FORM, function (app) {

    var dataStore = app.data;
    var helpers = app.helpers.funcs;

    return {

        // The jQuery DOM element that is the register form
        $formElem: null,

        // The JDA validator object - a wrapper around validateJS. Created on init().
        jdaValidator: null,

        useGreCaptcha: false,
        grecaptchaLoaded: false,
        grecaptchaId: false,

        isDomLoaded: false,
        isCaptchaScriptLoaded: false,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
                this.isDomLoaded = true;
            }
            if (data.hasJustLoaded(RESOURCE_NAME__GOOGLE_RECAPTCHA)) {
                this.useGreCaptcha = true;
                this.isCaptchaScriptLoaded = true;
            }
            if (!this.grecaptchaLoaded && this.isDomLoaded && this.isCaptchaScriptLoaded) {
                if ((!this.$formElem) || (!this.$formElem.length)) return;
                this.grecaptchaLoaded = true;
                this.grecaptchaId = app.helpers.funcs.protectFormInvisibleCaptcha(this.$formElem);
            }
        },

        // Runs in mediator start lifecycle
        init: function () {

            var scope = this;

            // Assign root DOM node, and halt execution if it is empty
            this.$formElem = $('#form-reset-password');
            if (!this.$formElem.length) return;

            // Create jda validator instance
            var baseConstraints = dataStore.get('validation.resetPasswordForm');
            this.jdaValidator = app.validator.build({}, this.$formElem);

            // Add constraints data to validator
            this.jdaValidator.constraintBag.addConstraints(baseConstraints);

            // Add DOM event listeners
            this.addDomListeners();

            // Add reCAPTCHA functionality: On submit, check for robot, check for validation, then submit
            this.$formElem.submit(function (e) {
                scope.handleFormSubmit(e);
            });

            app.mediator.notify(EVENT_NAME__RESET_PASSWORD_FORM__INITIATED);
        },

        //==========================================================xdiv2====
        // DOM event listeners
        //===================================================================

        addDomListeners: function () {
            var scope = this;
            this.$formElem.find('input[type=password]').keyup(function (e) {
                if (scope.jdaValidator.configuration.keyUpShouldBeIgnored(e)) return;
                var $elem = $(this);
                scope.handleElemChange($elem);
            });

        },

        //==========================================================xdiv2====
        // DOM event handlers
        //===================================================================

        handleFormSubmit: function (e) {
            var grecaptchaVal = null;

            if (this.useGreCaptcha) {
                grecaptchaVal = this.$formElem.find('[name="g-recaptcha-response"]').val();

                if (!this.grecaptchaLoaded) {
                    e.preventDefault();
                    var fallbackError = 'Please wait for the page to load before submitting the form.';
                    var error = window.serverData.generalLanguageStrings.captchaNotReady || fallbackError;
                    app.ui.uiPlugins.toast.fire(error, 'danger');
                    return;
                }
            }

            var messageBag = this.jdaValidator.getMessageBag();
            this.jdaValidator.presenter.clearStatuses();
            this.jdaValidator.presenter.showStatuses(messageBag);
            if (messageBag.hasMessages()) {
                e.preventDefault();
                this.jdaValidator.presenter.scrollToFirstError();
            } else {
                if (this.useGreCaptcha && !grecaptchaVal) {
                    e.preventDefault();
                    app.ui.uiPlugins.toast.fire('Please complete the CAPTCHA before submitting this form.', 'danger');
                }
            }
        },

        handleElemChange: function ($elem) {
            var formFieldId = this.jdaValidator.configuration.getFormFieldId($elem);
            var messageBag = this.jdaValidator.getMessageBagForFormField(formFieldId);
            this.jdaValidator.presenter.clearStatus($elem);
            this.jdaValidator.presenter.showStatus($elem, messageBag);
        }
    };
});
